import type { SupportContext } from "@b2bportal/rbc-hts-assist-api";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { HtsAssistEntryPoint } from "../components/HtsAssistChatWidget/htsAssistEntryTypes";

export interface HtsAssistChatEntry {
  // Raw pathname for routes without a known surface.
  entryPoint?: HtsAssistEntryPoint | string;
  supportContext?: SupportContext;
  entryAction?: string;
  initialUserQuery?: string;
}

export interface HtsAssistEntryState extends HtsAssistChatEntry {
  experience: "lobby" | "chat";
}

const initialState: HtsAssistEntryState = {
  experience: "chat",
};

const htsAssistEntrySlice = createSlice({
  name: "htsAssistEntry",
  initialState,
  reducers: {
    openHtsAssistLobby(
      _state,
      action: PayloadAction<Pick<HtsAssistChatEntry, "entryPoint"> | undefined>
    ) {
      return {
        experience: "lobby" as const,
        ...action.payload,
      };
    },
    openHtsAssistChat(_state, action: PayloadAction<HtsAssistChatEntry>) {
      return {
        experience: "chat" as const,
        ...action.payload,
      };
    },
    resetHtsAssistEntry() {
      return initialState;
    },
  },
});

export const { openHtsAssistChat, openHtsAssistLobby, resetHtsAssistEntry } =
  htsAssistEntrySlice.actions;

export const htsAssistEntryReducer = htsAssistEntrySlice.reducer;

export const getHtsAssistEntryState = (state: {
  htsAssistEntry: HtsAssistEntryState;
}) => state.htsAssistEntry;
